import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SplitButton, SplitButtonModule } from 'primeng/splitbutton';
import { BaseFieldControlComponent } from '@d-components/base-field-control/base-field-control';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionDirective } from 'app/core/directives/permission.directive';
import { ACTION_PERMISSION } from '@d-constants/permission.constant';
import { AuditService } from '@d-services/wms/audit.service';

@Component({
  selector: 'app-base-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    SplitButtonModule,
    TranslateModule,
    PermissionDirective,
  ],
})
export class BaseButtonComponent
  extends BaseFieldControlComponent
  implements OnInit
{
  @Input() outlined!: boolean;
  @Input() color: 'normal' | 'red' | 'yellow' | 'green' = 'normal';
  @Input() iconUrl!: string;
  @Input() rightIcon: boolean = false;
  @Input() iconName: string = '';
  @Input() type: 'normal' | 'split' = 'normal';
  @Input() buttonType: 'button' | 'submit' = 'button';
  @Input() splitButtonItems: {
    label: string;
    icon?: string;
    command?: () => void;
  }[] = [];
  @Input() splitOneClick = false;
  @Output() onClick = new EventEmitter();
  @Input() actionType?: string | string[];
  @Input() createdBy?: string;
  @Input() moduleCode?: any;
  @Input() buttonClass: string;
  constructor(private auditService: AuditService) {
    super();
  }

  actionPermission: {
    moduleCode: string | string[];
    actionType: string | string[];
  };

  ngOnInit(): void {
    if (this.type === 'split' && this.splitOneClick) {
      SplitButton.prototype.onDefaultButtonClick =
        SplitButton.prototype.onDropdownButtonClick;
    }

    if (this.actionPermission) {
      this.moduleCode = this.actionPermission.moduleCode;
      this.actionType = this.actionPermission.actionType;
    }
  }

  click($event: MouseEvent) {
    if (this.actionType && this.actionType === ACTION_PERMISSION.EXPORT) {
      this.auditService.createEventLog(
        this.moduleCode,
        ACTION_PERMISSION.EXPORT,
      );
    }

    this.onClick.emit($event);
  }
}
